import { FC } from 'react';
import { compose } from 'redux';
import { injectAnalyticsScope, injectReducer, injectTranslations, withTitle } from 'ia-react-core';
import fr from './translations/fr';
import en from './translations/en';
import UsernameFormPage, { UsernameFormPageProps } from './UsernameFormPage';
import { UsernameFormPageState } from '../../interfaces/UsernameFormPageState';
import usernameFormPageReducer from './UsernameFormPage.reducer';

export default compose<FC<UsernameFormPageProps>>(
  injectTranslations('UsernameFormPage', [
    { language: 'fr', resource: fr },
    { language: 'en', resource: en },
  ]),
  withTitle('UsernameFormPage:title'),
  injectReducer<UsernameFormPageProps, UsernameFormPageState>({
    key: 'features.account.username',
    reducer: usernameFormPageReducer,
    useScope: true,
    cleanState: true,
  }),
  injectAnalyticsScope({
    key: 'UsernameFormPage',
  }),
)(UsernameFormPage);
